import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row align-items-center py-4 mr-3"
}
const _hoisted_2 = { class: "d-flex w-100 align-items-center" }
const _hoisted_3 = { class: "h2 text-white d-inline-block mb-0" }
const _hoisted_4 = {
  "aria-label": "breadcrumb",
  class: "d-none d-md-inline-block ml-md-4"
}
const _hoisted_5 = {
  ref: "numCallsContainer",
  class: "media-body d-none text-white d-flex"
}
const _hoisted_6 = { ref: "totalCallsContainer" }
const _hoisted_7 = {
  class: "mb-0 text-sm font-weight-bold mr-2",
  style: {"white-space":"nowrap"}
}
const _hoisted_8 = {
  class: "mb-0 text-sm font-weight-bold mr-2",
  style: {"white-space":"nowrap"}
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" --> ")
const _hoisted_10 = { class: "navbar-nav align-items-center ml-4" }
const _hoisted_11 = { class: "nav-item d-xl-none" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "sidenav-toggler-inner" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "sidenav-toggler-line" }),
  /*#__PURE__*/_createElementVNode("i", { class: "sidenav-toggler-line" }),
  /*#__PURE__*/_createElementVNode("i", { class: "sidenav-toggler-line" })
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item d-sm-none" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link",
    href: "#",
    "data-action": "search-show",
    "data-target": "#navbar-search-main"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ni ni-zoom-split-in" })
  ])
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-volume-up el-icon" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "ni ni-bell-55" }, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "ni ni-bell-55"
}
const _hoisted_18 = {
  key: 0,
  class: "px-3 py-3"
}
const _hoisted_19 = {
  key: 0,
  class: "text-sm text-muted m-0 font-weight-normal"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Usted tiene ")
const _hoisted_21 = { class: "text-primary" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" nuevas notificaciones ")
const _hoisted_23 = {
  key: 1,
  class: "text-sm text-muted mt-2 text-center font-weight-normal"
}
const _hoisted_24 = {
  key: 2,
  class: "list-group list-group-flush"
}
const _hoisted_25 = { class: "row align-items-center flex-nowrap" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["src"]
const _hoisted_28 = {
  class: "notification-text mr-3",
  style: {"flex":"1"}
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_31 = { class: "mb-0 text-sm" }
const _hoisted_32 = { class: "text-right text-muted" }
const _hoisted_33 = { class: "text-sm mb-0" }
const _hoisted_34 = { class: "d-flex" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Cancelar ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Aceptar ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Ver todas ")
const _hoisted_38 = { class: "navbar-nav align-items-center ml-auto ml-md-0" }
const _hoisted_39 = { class: "media align-items-center" }
const _hoisted_40 = { class: "media-body ml-2 d-none d-lg-block" }
const _hoisted_41 = { class: "mb-0 text-sm font-weight-bold" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-header noti-title" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "text-overflow m-0" }, "Bienvenido!")
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "ni ni-single-02" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", null, "Mi perfil", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "ni ni-user-run" }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", null, "Logout", -1)
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 0 }

import BaseNav from "@/components/Navbar/BaseNav.vue";
import PauseControl from "@/components/PauseControl.vue";
import loginCallVue from "@/callcenter/loginCall.vue";
import {
	watch,
	withDefaults,
	computed,
	ref,
	onUnmounted,
} from "vue";
import { AuthModule } from "@/store/modules/Auth";
import { TicketModule } from "@/store/modules/Ticket";
import { useRouter } from "vue-router";
import { useDashboardNavbar } from "@/components/SidebarPlugin/index.js";
import { GuardRoles } from "@/types/router";
import Avatar from "@/views/Components/Navbar/Avatar.vue";
import {
	INotification,
	NotificationModule,
} from "@/store/modules/Notification";
import { DateTime } from "ts-luxon";
import BaseButton from "@/components/BaseButton.vue";
import NotificationLoading from "../Loadings/NotificationLoading.vue";
import { env } from "@/config/index";
import SoftPhone from "@/components/webPhone/main.vue";
import { useIdle } from "@vueuse/core";
import { useNotificationRef } from "@/plugins/notification";
import RouteBreadcrumb from "@/components/Breadcrumb/RouteBreadcrumb.vue";
import { Back, Ticket, ArrowRight, ArrowLeft } from "@element-plus/icons-vue";
import { socket } from "@/main";
import { disconnectResizeObserver } from "@/components/webPhone/components/js/draggBox";
import { CallDataModule } from "@/store/modules/CallData";
import { AlertModule } from "@/store/modules/Alert";
import offline from "@/components/offline.vue";
import { AppModule } from "@/store/modules/app";
import { OutputDeviceModule } from "@/store/modules/OutputDevice";
//Funcion que valida si los controles deben de estar activos
interface IDashNavBarProps {
	type: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    type: { default: "default" }
  },
  setup(__props: any) {

const props = __props as { type: string }

const enabledControls = computed(() => {
	return CallDataModule.getenableControls;
});

//Variable que indica si el usuario ha estado inactivo n cantidad de ms
const { idle } = useIdle(env.minForInactive * 60 * 1000);

const navbar = useDashboardNavbar();
// Props


// States
const router = useRouter();
const news = ref(NotificationModule.readed);
const showAll = ref(false);
const { loading, cancel, handleActions, notification } = useNotificationRef();

// Methods
function goBack() {
	AppModule.setShowNavbar(false);
	router.back();
}
const toggleSidebar = () => navbar.displaySidebar(!navbar.showSidebar);
const logout = () => {
	if (!enabledControls.value) {
		disconnectResizeObserver();
		AuthModule.logout();
	} else {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: "Debe de tipificar la llamada y finalizar gestión antes de cerrar sesión",
			type: "error",
		});
	}
};
function getTime(time: string) {
	return DateTime.fromISO(time).toRelative();
}
function openNotification(notification: INotification) {
	NotificationModule.setNotification(notification);
}

// Computed
const user = computed(() => AuthModule.user);
const extension = computed(() => AuthModule.extension);
const notifications = computed(() =>
	NotificationModule.notifications.filter(n => !n.read).splice(0, 5)
);
const showDeviceErrors = computed(() => (
	OutputDeviceModule.CallTestFailed ||
	OutputDeviceModule.RingTestFailed
))
//const loading = computed(() => NotificationModule.loading);
const requiredOmnichannel = !env.onlyCallcenter;
const callEnv = env.requiredCallcenter;
const fullAuth = computed(() => AuthModule.FullAuth);
// Methods
function assignTickets() {
	socket.emit("TICKET_AUTO_CLAIM", { token: AuthModule.token });
}
const queueCallsNumber = computed(() => CallDataModule.getQueueCalls);
const totalCallsNumber = computed(() =>
	Object.values(CallDataModule.getQueueCalls).reduce(
		(acc: number, curr: any) => acc + curr,
		0
	)
);
function expandToggle() {
	showAll.value = !showAll.value;
}
const gotoUserSettings = () => {
	OutputDeviceModule.setShowOutputDeviceSettings(true);
	router.push("/user")
}
// Watchs
watch(
	() => AuthModule.role,
	(role, prevRole) => {
		if (role === GuardRoles.GUEST && prevRole !== GuardRoles.GUEST)
			router.push("/login");
	}
);

watch(
	() => NotificationModule.readed,
	() => {
		news.value = NotificationModule.readed;
	}
);

watch(
	() => idle.value,
	() => {
		if (idle.value === true) {
			AuthModule.setActivity(true);
		}
	}
);
onUnmounted(() => CallDataModule.setCallsInQueue({}));

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_dropdown = _resolveComponent("base-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BaseNav, {
      "container-classes": "container-fluid",
      class: _normalizeClass(["navbar-top border-bottom navbar-expand", { 'bg-success navbar-dark': props.type === 'default' }])
    }, {
      default: _withCtx(() => [
        (_unref(AppModule).showNavbar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_button, {
                  onClick: goBack,
                  icon: _unref(Back),
                  class: "mr-2",
                  circle: "",
                  size: "small"
                }, null, 8, ["icon"]),
                _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$route.name), 1),
                _createElementVNode("nav", _hoisted_4, [
                  _createVNode(RouteBreadcrumb)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("ul", {
          class: _normalizeClass(["navbar-nav align-items-center", _unref(env).GetQueueIncoming ? 'mr-md-auto' : 'ml-md-auto'])
        }, [
          (_unref(env).GetQueueIncoming)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                class: "box-item",
                effect: "dark",
                content: "Llamadas en cola",
                placement: "bottom-start",
                "popper-options": {
					modifiers: [
						{
							name: 'preventOverflow',
							options: {
								mainAxis: false,
								tether: false,
							},
						},
					],
				}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("li", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, " Total: " + _toDisplayString(_unref(totalCallsNumber)), 1)
                    ], 512),
                    _createElementVNode("div", {
                      class: "d-flex overflow-hidden align-items-center",
                      style: _normalizeStyle([{"transition":"all 0.34s ease"}, { width: showAll.value ? '100%' : '0%' }])
                    }, [
                      _createVNode(_component_el_divider, { direction: "vertical" }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(queueCallsNumber), (value, key) => {
                        return (_openBlock(), _createElementBlock("li", { key: key }, [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(key) + ": " + _toDisplayString(value), 1)
                        ]))
                      }), 128))
                    ], 4),
                    (!showAll.value)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          onClick: expandToggle,
                          icon: _unref(ArrowRight),
                          size: "small",
                          circle: ""
                        }, null, 8, ["icon"]))
                      : (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          onClick: expandToggle,
                          icon: _unref(ArrowLeft),
                          size: "small",
                          circle: ""
                        }, null, 8, ["icon"]))
                  ], 512),
                  _hoisted_9
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("ul", _hoisted_10, [
          _createElementVNode("li", _hoisted_11, [
            _createElementVNode("div", {
              class: _normalizeClass(["pr-3 sidenav-toggler", {
						active: _unref(navbar).showSidebar,
						'sidenav-toggler-dark': props.type === 'default',
						'sidenav-toggler-light': props.type === 'light',
					}]),
              onClick: toggleSidebar
            }, _hoisted_13, 2)
          ]),
          _hoisted_14,
          (_unref(showDeviceErrors))
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                content: "Se ha detectado un problema con la configuración de dispositivos de salida"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "danger",
                    onClick: gotoUserSettings,
                    circle: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (
					_unref(router).currentRoute.value.name === 'Messages' &&
						_unref(TicketModule).totalOpen > 0
				)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 1,
                content: "Reclamar tickets"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    icon: _unref(Ticket),
                    onClick: assignTickets,
                    circle: ""
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(PauseControl, { style: {"padding-left":"1rem !important"} }),
          requiredOmnichannel
            ? (_openBlock(), _createBlock(_component_base_dropdown, {
                key: 2,
                class: "nav-item",
                tag: "li",
                "title-classes": "nav-link",
                "title-tag": "a",
                "menu-classes": "dropdown-menu-xl dropdown-menu-right py-0 overflow-hidden no-pointer"
              }, {
                title: _withCtx(() => [
                  (news.value > 0)
                    ? (_openBlock(), _createBlock(_component_el_badge, {
                        key: 0,
                        value: news.value,
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      }, 8, ["value"]))
                    : (_openBlock(), _createElementBlock("i", _hoisted_17))
                ]),
                default: _withCtx(() => [
                  (!_unref(loading) || _unref(notification).length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        (_unref(notifications).length)
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_19, [
                              _hoisted_20,
                              _createElementVNode("strong", _hoisted_21, _toDisplayString(_unref(notifications).length), 1),
                              _hoisted_22
                            ]))
                          : (_openBlock(), _createElementBlock("h6", _hoisted_23, " No tiene notificaciones sin atender "))
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(loading) && !_unref(notification))
                    ? (_openBlock(), _createBlock(NotificationLoading, {
                        key: 1,
                        loading: _unref(loading) && !_unref(notification),
                        class: "mt-4 mb-2"
                      }, null, 8, ["loading"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications), (notify) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: notify._id,
                            class: "list-group-item list-group-item-action"
                          }, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", {
                                class: "mx-3 can-hover",
                                style: {"width":"50px"},
                                onClick: () => openNotification(notify)
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["avatar avatar-sm rounded-circle", {
										'no-background': !(
											(notify.icon?.indexOf('http') ?? -1) > -1
										),
									}]),
                                  style: {"width":"50px","height":"50px"}
                                }, [
                                  ((notify.icon?.indexOf('http') ?? -1) > -1)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        alt: "Image placeholder",
                                        src: notify.icon
                                      }, null, 8, _hoisted_27))
                                    : (_openBlock(), _createElementBlock("i", {
                                        key: 1,
                                        style: {"font-size":"2rem"},
                                        class: _normalizeClass(["text-gray", notify.icon ?? 'fas fa-bell'])
                                      }, null, 2))
                                ], 2)
                              ], 8, _hoisted_26),
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", {
                                  class: "can-hover",
                                  onClick: () => openNotification(notify)
                                }, [
                                  _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("h4", _hoisted_31, _toDisplayString(notify.title), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_32, [
                                      _createElementVNode("small", null, _toDisplayString(getTime(notify.createdAt)), 1)
                                    ])
                                  ]),
                                  _createElementVNode("p", _hoisted_33, _toDisplayString(notify.description), 1)
                                ], 8, _hoisted_29),
                                _createElementVNode("div", _hoisted_34, [
                                  (notify.button)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(BaseButton, {
                                          link: "",
                                          type: "secondary",
                                          size: "sm",
                                          loading: 
												_unref(loading) && _unref(cancel) && _unref(notification) === notify._id
											,
                                          onClickCapture: _withModifiers(
												() => _unref(handleActions)(`read`, notify._id)
											, ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_35
                                          ]),
                                          _: 2
                                        }, 1032, ["loading", "onClickCapture"]),
                                        _createVNode(BaseButton, {
                                          link: "",
                                          class: "text-white ml-auto",
                                          type: "primary",
                                          size: "sm",
                                          loading: 
												_unref(loading) && !_unref(cancel) && _unref(notification) === notify._id
											,
                                          onClickCapture: _withModifiers(
												() => _unref(handleActions)(notify.action, notify._id)
											, ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_36
                                          ]),
                                          _: 2
                                        }, 1032, ["loading", "onClickCapture"])
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])),
                  _createVNode(_component_router_link, {
                    to: "/widgets/notifications",
                    class: "dropdown-item text-center text-primary font-weight-bold py-3"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_37
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(env).requiredCallcenter)
            ? (_openBlock(), _createBlock(loginCallVue, { key: 3 }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("ul", _hoisted_38, [
          _createVNode(_component_base_dropdown, {
            "menu-on-right": "",
            class: "nav-item",
            tag: "li",
            "title-tag": "a",
            "title-classes": "nav-link pr-0"
          }, {
            "title-container": _withCtx(() => [
              _createElementVNode("a", {
                href: "#",
                class: "nav-link pr-0",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(Avatar, {
                    picture: _unref(user)?.picture
                  }, null, 8, ["picture"]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(user)?.username) + " [" + _toDisplayString(_unref(extension)) + "] ", 1)
                  ])
                ])
              ])
            ]),
            default: _withCtx(() => [
              _hoisted_42,
              _createVNode(_component_router_link, {
                to: "/user",
                class: "dropdown-item"
              }, {
                default: _withCtx(() => [
                  _hoisted_43,
                  _hoisted_44
                ]),
                _: 1
              }),
              _hoisted_45,
              _createElementVNode("a", {
                onClick: logout,
                class: "dropdown-item"
              }, _hoisted_48)
            ]),
            _: 1
          })
        ]),
        _createVNode(offline)
      ]),
      _: 1
    }, 8, ["class"]),
    (_unref(callEnv))
      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
          (_unref(fullAuth))
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createVNode(SoftPhone)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})